var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDropdownFilled = function SvgDropdownFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.972 8A5.972 5.972 0 1 1 2.028 8a5.972 5.972 0 0 1 11.944 0m-3.313-.412c-.582.885-1.37 2.037-2.165 2.898h-.006a.69.69 0 0 1-.982 0c-.794-.861-1.577-2.013-2.165-2.898-.272-.382-.018-.976.498-.964h4.323c.515-.012.77.582.497.964",
    clipRule: "evenodd"
  })));
};
export default SvgDropdownFilled;